(function () {
  // For product page bundle configuration
  // Show bundle configuration
  let startBundleBtn = document.getElementById("start_bundle_btn");

  // When startBundleBtn is clicked, show the bundle configuration
  startBundleBtn?.addEventListener("click", function () {
    let bundleConfig = document.getElementById("product_bundle");
    let startBundleContainer = document.getElementById("product_bundle_start");
    bundleConfig.style.display = "grid";
    startBundleContainer.style.display = "none";
  });

})();
